export const priceReferenceRulerDefaultProps = {
  adPrice: 'R$ 14900',
  percentageFromMedianPrice: 10,
  quartile: 1,
  quartileColors: {
    highlighted: ['var(--color-feedback-info-90)', 'var(--color-feedback-info-100)', 'var(--color-feedback-info-110)'],
    normal: ['var(--color-feedback-info-90)', 'var(--color-feedback-info-100)', 'var(--color-feedback-info-110)']
  },
  olxPrice: {
    price_p50: 17500,
    price_max: 30000,
    price_min: 10000,
    price_p33: 15000,
    price_p66: 20000
  },
  hideWithoutPriceInput: false
};